<!-- Page body start -->
<div class="page-body">
  <div class="row">
    <div class="col-sm-12">
      <!-- Post comment card start -->
      <div class="card">
        <div class="card-header">
          <h5>Your settings</h5>
          <span>Change various settings for your profile </span>
          <div class="card-header-right">
            <i class="icofont icofont-spinner-alt-5"></i>
          </div>
        </div>

        <list-errors [errors]="errors"></list-errors>

        <div class="card-block">
          <div class="j-wrapper j-wrapper-640">
            <form
              class="j-pro form-control md-float-material"
              id="j-pro"
              (keydown.enter)="$event.preventDefault()"
            >
              <div class="j-content">
                <div class="j-row">
                  <!-- start image -->
                  <div class="j-span12 j-unit">
                    <div>
                      <h5 class="sub-title">Upload image</h5>
                    </div>
                    <div class="j-input">
                      <label class="j-icon-left" for="image">
                        <i class="icofont icofont-camera"></i>
                      </label>
                      <input
                        [formControl]="imageSettingsField"
                        type="text"
                        id="image"
                        name="image"
                        placeholder="URL of profile picture"
                        class="name-group"
                      />
                    </div>
                  </div>
                  <!-- end image -->

                  <!-- start add photo -->
                  <div class="j-span12 j-unit text-center">
                    <upload-image-button
                      [targetObject]="currentUser"
                      [targetType]="'User'"
                      (emitImage)="saveImage($event)"
                    >
                    </upload-image-button>
                  </div>
                  <!-- end add photo -->

                  <!-- start username -->
                  <div class="j-span12 j-unit">
                    <div>
                      <h5 class="sub-title">User name</h5>
                    </div>
                    <div class="j-input">
                      <label class="j-icon-left" for="username">
                        <i class="icofont icofont-id"></i>
                      </label>
                      <input
                        [formControl]="usernameSettingsField"
                        type="text"
                        id="username"
                        name="username"
                        placeholder="Your Username?"
                        class="name-group"
                      />
                    </div>
                  </div>
                  <!-- start username -->

                  <!-- start bio -->
                  <div class="j-span12 j-unit">
                    <div>
                      <h5 class="sub-title">Bio</h5>
                    </div>
                    <div class="j-input">
                      <label class="j-icon-left" for="bio">
                        <i class="icofont icofont-ui-user"></i>
                      </label>
                      <textarea
                        [formControl]="bioSettingsField"
                        rows="100"
                        placeholder="Short bio about you"
                        id="bio"
                        name="bio"
                      ></textarea>
                    </div>
                  </div>
                  <!-- end bio -->

                  <!-- start email -->
                  <div class="j-span12 j-unit">
                    <div>
                      <h5 class="sub-title">Email</h5>
                    </div>
                    <div class="j-input">
                      <label class="j-icon-left" for="email">
                        <i class="icofont icofont-id"></i>
                      </label>
                      <input
                        [formControl]="emailSettingsField"
                        type="email"
                        id="email"
                        name="email"
                        placeholder="Change your email?"
                        class="name-group"
                      />
                    </div>
                  </div>
                  <!-- end email -->

                  <!-- link social media -->
                  <div [hidden]="true" class="col-12">
                    <h5 class="sub-title">
                      Link your social media accounts for faster sign-in
                    </h5>
                    <!-- Facebook social auth button -->
                    <div class="col-12">
                      <social-auth-button
                        [provider]="'Facebook'"
                        [useCase]="'link'"
                      ></social-auth-button>
                    </div>

                    <!-- Twitter social auth button -->
                    <div class="col-12">
                      <social-auth-button
                        [provider]="'Twitter'"
                        [useCase]="'link'"
                      ></social-auth-button>
                    </div>

                    <!-- Google social auth button -->
                    <div class="col-12">
                      <social-auth-button
                        [provider]="'Google'"
                        [useCase]="'link'"
                      ></social-auth-button>
                    </div>
                    <div
                      class="checkbox-zoom"
                      [ngClass]="{
                        'zoom-default': !currentUser.facebookLinked,
                        'zoom-primary': currentUser.facebookLinked
                      }"
                    >
                      <label>
                        <input
                          *ngIf="currentUser.facebookLinked"
                          type="checkbox"
                          value=""
                          checked
                        />
                        <input
                          *ngIf="!currentUser.facebookLinked"
                          type="checkbox"
                          value=""
                        />
                        <span class="cr">
                          <i
                            class="cr-icon icofont icofont-ui-check"
                            [ngClass]="{
                              'text-default': !currentUser.facebookLinked,
                              'text-primary': currentUser.facebookLinked
                            }"
                          ></i>
                        </span>
                        <i
                          class="fa fa-facebook"
                          [ngClass]="{
                            'text-default': !currentUser.facebookLinked,
                            'text-primary': currentUser.facebookLinked
                          }"
                        ></i>
                        <span>Facebook: </span>
                        <span *ngIf="!currentUser.facebookLinked">
                          Not linked
                        </span>
                        <span *ngIf="currentUser.facebookLinked">
                          Account linked
                        </span>
                      </label>
                    </div>
                    <div
                      class="checkbox-zoom"
                      [ngClass]="{
                        'zoom-default': !currentUser.twitterLinked,
                        'zoom-primary': currentUser.twitterLinked
                      }"
                    >
                      <label>
                        <input
                          *ngIf="currentUser.twitterLinked"
                          type="checkbox"
                          value=""
                          checked
                        />
                        <input
                          *ngIf="!currentUser.twitterLinked"
                          type="checkbox"
                          value=""
                        />
                        <span class="cr">
                          <i
                            class="cr-icon icofont icofont-ui-check"
                            [ngClass]="{
                              'text-default': !currentUser.twitterLinked,
                              'text-primary': currentUser.twitterLinked
                            }"
                          ></i>
                        </span>
                        <i
                          class="fa fa-twitter"
                          [ngClass]="{
                            'text-default': !currentUser.twitterLinked,
                            'text-primary': currentUser.twitterLinked
                          }"
                        ></i>
                        <span>Twitter: </span>
                        <span *ngIf="!currentUser.twitterLinked">
                          Not linked
                        </span>
                        <span *ngIf="currentUser.twitterLinked">
                          Account linked
                        </span>
                      </label>
                    </div>
                    <div
                      class="checkbox-zoom"
                      [ngClass]="{
                        'zoom-default': !currentUser.googleLinked,
                        'zoom-primary': currentUser.googleLinked
                      }"
                    >
                      <label>
                        <input
                          *ngIf="currentUser.googleLinked"
                          type="checkbox"
                          value=""
                          checked
                        />
                        <input
                          *ngIf="!currentUser.googleLinked"
                          type="checkbox"
                          value=""
                        />
                        <span class="cr">
                          <i
                            class="cr-icon icofont icofont-ui-check"
                            [ngClass]="{
                              'text-default': !currentUser.googleLinked,
                              'text-primary': currentUser.googleLinked
                            }"
                          ></i>
                        </span>
                        <i
                          class="fa fa-google"
                          [ngClass]="{
                            'text-default': !currentUser.googleLinked,
                            'text-primary': currentUser.googleLinked
                          }"
                        ></i>
                        <span>Google: </span>
                        <span *ngIf="!currentUser.googleLinked">
                          Not linked
                        </span>
                        <span *ngIf="currentUser.googleLinked">
                          Account linked
                        </span>
                      </label>
                    </div>
                    <hr />
                  </div>
                  <!-- link social media -->

                  <!-- start password -->
                  <div class="j-span12 j-unit">
                    <div>
                      <h5 class="sub-title">Change your password</h5>
                    </div>
                    <div class="j-input">
                      <label class="j-icon-left" for="password">
                        <i class="icofont icofont-key"></i>
                      </label>
                      <input
                        [formControl]="passwordSettingsField"
                        type="password"
                        id="password"
                        name="password"
                        placeholder="Type new password here to change your password"
                        class="name-group"
                      />
                    </div>
                  </div>
                  <!-- end password -->

                  <!-- delete account button -->
                  <div class="j-span12 j-unit">
                    <div>
                      <h5 class="sub-title">Delete account</h5>
                    </div>
                    <div class="j-input">
                      <del-account-button
                        *ngIf="currentUser"
                        [currentUser]="currentUser"
                      >
                      </del-account-button>
                    </div>
                  </div>
                  <!-- delete account button -->

                  <!-- end description -->
                </div>
              </div>
              <!-- end /.content -->
              <div class="j-footer">
                <button
                  type="submit"
                  class="btn btn-primary"
                  (click)="openSettingSaveConfirmation()"
                >
                  <i class="icofont icofont-paper-plane"></i>
                  Update Settings
                </button>

                <button class="btn btn-warning" (click)="logout()">
                  <i class="icofont icofont-logout"></i>
                  Or logout here!
                </button>
              </div>
              <!-- end /.footer -->
            </form>
          </div>
        </div>
      </div>
      <!-- Post comment card end -->
    </div>
  </div>
</div>
<!-- Page body end -->
